import React, { Component } from "react";
import { withRedux } from "helpers";
import { Form, FlexRow, H1, H2, Button } from "appStyles";
import { SaveProgress, RadioOptions } from "components";
import EditBackground from "../EditBackground";
import "@material/radio/dist/mdc.radio.css";
import "@material/form-field/dist/mdc.form-field.css";
import { css } from "react-emotion";
import { redemptionTypeOptions } from "constants";
import { imageView } from "defaultStates";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Deal from "./Deal";

const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  padding: 20px;
  position: relative;
  padding: 1em;
  border-radius: 5px;
  margin-bottom: 3em;
  margin-top: 1em;
`;

class DealSettings extends Component {
  state = {
    croppingAspectRatio: "1.0",
    showModal: false,
  };
  constructor(props) {
    super(props);
  }
  update = (field) => (value) => {
    // console.log("updating with field: " + field + " and value: " + value);
    this.props.actions.updateApplication(field, value);
  };

  updatePic = (field) => (value) => {
    this.setState({ [field]: value });
  };

  addTempDeal = () => {
    this.props.actions.addTempDeal();
    this.props.actions.updateActiveEditor("newDeal");
    this.setState({ showModal: true });
  };

  hasDeal = () => Object.keys(this.props.deals).length > 0;
  updateComponent = (component) => {
    const { activeTemplate } = this.props;
    const updatedTemplate = {
      ...this.props.activeTemplate,
    };
    updatedTemplate.components = activeTemplate.components.map((c) =>
      c.componentNumber === component.componentNumber ? component : c
    );
    this.props.actions.updateTemplate(updatedTemplate);
  };
  updateBackgroundColor = (backgroundColor) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      backgroundColor,
    };

    this.props.actions.updateTemplate(updatedTemplate);
  };

  updateBackgroundImage = (url) => {
    // "updating background image");
    let updatedTemplate = this.props.activeTemplate;
    if (url) {
      if (updatedTemplate.backgroundImage === null) {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: imageView(url),
        };
      } else {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: {
            ...this.props.activeTemplate.backgroundImage,
            url,
          },
        };
      }
    } else {
      updatedTemplate = {
        ...this.props.activeTemplate,
        backgroundImage: null,
      };
    }

    this.props.actions.updateTemplate(updatedTemplate);
  };

  renderPageSettings = () => {
    // if (!this.hasDeal()) return null;
    const { activeApp, activeTemplate, activeEditor } = this.props;
    const { croppingAspectRatio } = this.state;
    return (
      <div className={container}>
        <EditBackground
          croppingAspectRatio={croppingAspectRatio}
          update={this.updatePic}
          updateComponent={this.updateComponent}
          pictureCatalogComponent={
            activeTemplate.type === "pictureCatalog"
              ? activeTemplate.components[0]
              : false
          }
          updateBackgroundColor={this.updateBackgroundColor}
          updateBackgroundImage={this.updateBackgroundImage}
          backgroundColor={activeTemplate.backgroundColor}
          backgroundImage={activeTemplate.backgroundImage}
          additionalPageSettings={this.additionalPageSettings}
          appId={activeApp.id}
        />
        <SaveProgress />
      </div>
    );
  };
  renderDealRedemptionType = () => {
    // if (!this.hasDeal()) return null;

    const { dealRedemptionType } = this.props.activeApp;
    const { activeApp } = this.props;
    const isManual = dealRedemptionType == 1;
    const isCustomerScans = dealRedemptionType == 2;
    return (
      <React.Fragment>
        <div>
          <div
            style={{
              display: "flex",
              width: "310px",
              alignItems: "center",
              margin: "15px 0px",
            }}
          >
            <H2
              fontSize="20px"
              lineHeight="29px"
              className="dealRedemption"
              width="290px"
              fontWeight="normal"
              margin="0px"
            >
              Deal Redemption Type
            </H2>
            {/* <HintModal
              modalLeft="2em"
              position="relative"
              width="470px"
              height="auto"
              margin="auto auto auto 8px"
            >
              <div
                style={{
                  fontSize: "0.9em"
                }}
              >
                <p>
                  You can choose how to verify deal usage by enforcing
                  verification before the deal is redeemed. You may choose:
                </p>
                <br />
                <p>
                  1. Manual Entry - When redeeming a deal, a customer must
                  request your staff member to type in the deal you have
                  specified above.
                </p>
                <br />
                <p>
                  2. Customer Scans QR - When redeeming a deal, a customer must
                  scan your unique QR code which can be downloaded and printed
                  above in the "deal code" section.
                </p>
                <br />
                <p>
                  3. Business Scans Customer QR - When the customer redeems a
                  deal, a QR code will pop up on their phone. Using your admin
                  panel in the Mobile360 app, scan the customers QR code.
                </p>
              </div>
            </HintModal> */}
          </div>
        </div>
        <p
          style={{
            fontSize: "12px",
            lineHeight: "14px",
            color: "#8C8C8C",
            margin: "15px 5px",
          }}
          className="dealPassword"
        >
          Select how customers can redeem deals in their app
        </p>
        <FlexRow width="100%" height="auto">
          {/* <SelectOptions
            width="330px"
            containerWidth="300px"
            value={dealRedemptionType}
            options={redemptionTypeOptions}
            setValue={this.update("dealRedemptionType")}
          /> */}
          <RadioOptions
            {...this.props}
            // value={redemptionType}
            value={dealRedemptionType}
            options={redemptionTypeOptions}
            setValue={this.update("dealRedemptionType")}
            showPasswordInput={isManual}
            showQRCode={isCustomerScans}
            pageType="deal"
          ></RadioOptions>
        </FlexRow>
      </React.Fragment>
    );
  };

  updatePageName = (pageName) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      pageName,
    };
    this.props.actions.updateTemplate(updatedTemplate);
  };

  render() {
    const hasNewDeal = this.props.deals.newDeal;
    const {
      deals,
      activeEditor,
      activeApp: { id },
    } = this.props;
    // console.log("deal actions");
    // JSON.stringify(this.props.actions);
    // console.log(this.props.actions);

    const activeDeal = deals[activeEditor];
    return (
      <div>
        {this.renderPageSettings()}
        <Form marginBottom="3em">
          <H1
            fontSize="24px"
            className="heading"
            lineHeight="35px"
            style={{ letterSpacing: "2px", textAlign: "left" }}
          >
            Deal Settings
          </H1>
          {/* <FlexRow>
          <H2 width="290px" margin="inherit">
            Page Title:{" "}
          </H2>
          <Input
            field="Page Title"
            defaultValue={pageName}
            onChange={this.updatePageName}
            type="text"
            height="5%"
            width="67%"
            color="black"
            textColor="black"
          />
        </FlexRow> */}

          {this.renderDealRedemptionType()}
          <br />

          {/* {!hasNewDeal && (
            <Button
              background="#89d2d3"
              onClick={this.addTempDeal}
              style={{
                display: "inline-block",
                width: "182px",
                textAlign: "center",
                borderRadius: "5.5px",
                fontSize: "15px",
                fontWeight: "bold",
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: "normal",
                letteSpacing: "normal",
                textTransform: "none"
              }}
            >
              Create New Deal
            </Button>
          )} */}

          <div style={{ textAlign: "center" }}>
            <Button
              onClick={this.addTempDeal}
              className="newDealButton"
              style={{
                marginLeft: " 0px",
                marginBottom: "40px",
                display: "inline-flex",
                alignItems: "center",
                textAlign: "center",
                fontSize: "15px",
                lineHeight: "29px",
                borderRadius: "5.5px",
                backgroundColor: "#89d2d3",
                fontWeight: "bold",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                fontStyle: "normal",
                fontStretch: "normal",
                textTransform: "none",
              }}
            >
              <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
              Create New Deal
            </Button>
          </div>
          <SaveProgress />
        </Form>

        {/* <AlertModal title={"Deals Modal Test"} render={this.state.showModal}>
          <Deal appId={id} {...this.props.actions} deal={activeDeal}></Deal>
          <p>This is a test</p>
        </AlertModal> */}
      </div>
    );
  }
}

export default withRedux(DealSettings);
